
























import { defineComponent, ref } from '@nuxtjs/composition-api';
import VehiclesList from '@shared/components/Vehicles/VehiclesList.vue';
import useFitment from '@shared/composables/useFitment';
import useMyGarage from '@shared/composables/useMyGarage';
import { GarageVehicle } from '@shared/composables/useMyGarage/types';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { UCButtonGroup } from '@shared/ui';

import AMXButton from '~/components/AMXButton.vue';
import ListEmptyMessage from '~/components/VehiclesSideBar/ListEmptyMessage.vue';
import SidebarHeading from '~/components/VehiclesSideBar/SidebarHeading.vue';

export default defineComponent({
  name: 'VehiclesGarage',
  components: { UCButtonGroup, ListEmptyMessage, AMXButton, SidebarHeading, VehiclesList },
  setup() {
    const { navigateToParts } = useFitment();
    const { vehicles, selectedVehicle, setSelectedVehicle, removeVehicle } = useMyGarage();
    const selected = ref<GarageVehicle | undefined>(selectedVehicle.value);
    const { open, close } = useVehiclesSidebar();

    const onVehicleSelectionChanged = (vehicle: GarageVehicle) => {
      selected.value = vehicle;
    };

    const onAddBikeClicked = () => {
      open();
    };

    const onVehicleRemoved = (vehicle: GarageVehicle) => {
      removeVehicle(vehicle);
      selected.value = selectedVehicle.value;
    };

    const onShopPartsClicked = () => {
      if (!selected.value) return;
      setSelectedVehicle(selected.value);
      close();
      navigateToParts();
    };

    return {
      vehicles,
      selected,
      onAddBikeClicked,
      onVehicleSelectionChanged,
      onVehicleRemoved,
      onShopPartsClicked,
    };
  },
});
